import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const header = css({
  textAlign: "center",
  height: 50,
  lineHeight: "50px",
});

export const container = css({
  display: "grid",
  grid: "1fr 1fr / 1fr 1fr",
  minWidth: 528,
  padding: 20,
  gap: 10,
});

export const helperIcon = css({
  marginLeft: "auto",
  marginTop: 5,
  alignSelf: "flex-start",
});

export const root = ({ colorsV2, borderRadiusV2 }: ExactTheme) =>
  css({
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    gap: 15,
    height: 65,
    paddingLeft: 15,
    paddingRight: 5,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colorsV2.blue[500],
    borderRadius: borderRadiusV2.primary,
    color: colorsV2.blue[500],
    backgroundColor: "#fff",
    transition: "background-color 0.3s, color 0.3s, border-color 0.3s",
    cursor: "pointer",
    whiteSpace: "nowrap",

    ":hover": {
      backgroundColor: colorsV2.blue[500],
      color: "#fff",

      span: {
        color: "#fff",
      },
      i: {
        color: "#fff",
      },
    },

    ":active": {
      backgroundColor: colorsV2.blue[700],
      borderColor: colorsV2.blue[700],
    },
  });

export const buttonText = ({
  colorsV2,

  fontSizesV2,
  fontWeights,
}: ExactTheme) =>
  css({
    fontSize: fontSizesV2.body,
    fontWeight: fontWeights.bold,
    color: colorsV2.blue[800],
    transition: "color 0.3s",
  });

export const icon = css({
  transition: "color 0.3s",
});
